<template>
  <div>
    <div style="padding-bottom: 20px" class="d-flex flex-row justify-content-between">
      <div style="color: #89A9DA;">
        Yandex Alice - Blocker
      </div>
    </div>
    <div v-if="authForm.authorized" style="padding-bottom: 20px;">
      <GChart v-if="chartData.length > 1" type="AreaChart" :data="chartData" />
    </div>
    <div class="d-flex flex-row" v-if="authForm.authorized">
      <b-alert
        :show="errorMessage"
        variant="danger"
        class="text-center"
      >
        {{errorMessage}}
      </b-alert>
      <div style="width: 960px">
        <b-form class="d-flex " @submit="prevent" style="padding-bottom: 20px;">
          <div class="d-flex">
            <span style="color: #CCCCDC;">SEARCH:</span>
            <b-form-input v-model="params.filter" :state="paramsState.filter" size="sm" type="number" style="width: 200px; margin-left: 10px;" />
          </div>
          <div class="d-flex" style="margin-left: 20px;">
            <span style="color: #CCCCDC;">Start:</span>
            <b-form-input v-model="params.period.start" type="time" size="sm" style="width: 60px; margin-left: 10px;" />
            <span style="margin-left: 10px; color: #CCCCDC;">End:</span>
            <b-form-input v-model="params.period.end" type="time" size="sm" style="width: 60px; margin-left: 10px;" />
          </div>
          <div class="d-flex" style="margin-left: 20px;">
            <span style="color: #CCCCDC;">Hide Blocked</span>
            <b-form-checkbox v-model="params.hide" :value="true" :unchecked-value="false" size="lg" style="width: 50px; margin-left: 10px;" />
          </div>
        </b-form>
        <div>
          <b-table striped hover :dark="true" :fields="table.fields" :items="table.items" small>
            <template #table-colgroup="scope">
              <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.key === 'block' ? '50px' : '200px' }"
              >
            </template>
            <template #cell(block)="data">
              <b-form-checkbox v-model="table.items[data.index].blocked" @change="saveBlock(data.index)" :value="true" :unchecked-value="false" size="lg" style="width: 50px" class="text-center" />
            </template>
            <template #cell(description)="data">
              <b-form-input size="sm" v-model="table.items[data.index].description" @keyup.native="saveDescription(data.index)"></b-form-input>
            </template>
          </b-table>
        </div>
      </div>
      <div class="d-flex flex-column text-center" style="width: 150px">
        <span style="color: #CCCCDC;">Data base:</span>
        <b-button-group vertical>
          <b-button v-for="item of dates" :key="item" size="sm" variant="link" @click="params.date = item" :style="params.date === item ? 'color: #89A9DA;' : 'color: #777883;'">> {{item}}</b-button>
        </b-button-group>
      </div>
    </div>
    <div v-else>
      <b-alert
        :show="authForm.authError"
        variant="danger"
        class="text-center"
      >
        Error! Your login or password incorrect or service unavailable.
      </b-alert>
      <b-form @submit="authorize" class="d-flex flex-column">
        <b-form-group>
          <b-form-input v-model="authForm.login" type="text" placeholder="LOGIN" />
        </b-form-group>
        <b-form-group>
          <b-form-input v-model="authForm.password" type="password" placeholder="PASSWORD" />
        </b-form-group>
        <b-button type="submit" variant="success">Log in</b-button>
      </b-form>
    </div>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts/legacy'
import api from '../api'

export default {
  components: {
    GChart,
  },
  data() {
    return {
      chartData: [],
      authForm: {
        login: '',
        password: '',
        authorized: false,
        authError: false,
      },
      params: {
        filter: '',
        period: {
          start: '',
          end: '',
        },
        date: '',
        hide: false,
      },
      paramsState: {
        filter: null,
      },
      table: {
        fields: [
          { key: 'count', sortable: true },
          { key: 'object_id' },
          { key: 'block' },
          { key: 'description' },
        ],
        items: [],
      },
      dates: [],
      saveDescriptionTimeout: null,
      errorMessage: null,
    }
  },
  beforeMount() {
    document.body.style.backgroundColor = '#181B1F'
  },
  beforeUnmount() {
    document.body.style.backgroundColor = '#FFFFFF'
  },
  mounted() {
    const date = new Date()
    this.params.date = date.toLocaleDateString()
    // eslint-disable-next-line no-plusplus
    for (let i = 1; i < 31; i++) {
      this.dates.push(date.toLocaleDateString())
      date.setDate(date.getDate() - 1)
    }
    if (sessionStorage.getItem('yb_token')) {
      this.authForm.authorized = true
      this.load()
      this.loadChart()
    }
  },
  watch: {
    // eslint-disable-next-line func-names
    'params.filter': function (val) {
      if (val.length >= 3) {
        this.load()
        this.paramsState.filter = true
      } else if (val.length > 0) {
        this.paramsState.filter = false
      } else {
        this.load()
        this.paramsState.filter = null
      }
    },
    // eslint-disable-next-line func-names
    'params.hide': function () {
      this.load()
    },
    // eslint-disable-next-line func-names
    'params.period.start': function () {
      this.load()
    },
    // eslint-disable-next-line func-names
    'params.period.end': function () {
      this.load()
    },
    // eslint-disable-next-line func-names
    'params.date': function () {
      this.load()
      this.loadChart()
    },
  },
  methods: {
    prevent(event) {
      event.preventDefault()
    },
    saveBlock(index) {
      const item = this.table.items[index]
      api.cwsBack.post('/yandex_blocker/block/save', {
        object_id: item.object_id,
        blocked: item.blocked,
      }, {
        headers: {
          Authorization: sessionStorage.getItem('yb_token'),
        },
      }).catch(({ response }) => {
        if (response.status === 401) {
          sessionStorage.removeItem('yb_token')
          this.authForm.authorized = false
        }
      })
    },
    saveDescription(index) {
      clearTimeout(this.saveDescriptionTimeout)
      this.saveDescriptionTimeout = setTimeout(() => {
        this.saveDescriptionRequest(index)
      }, 200)
    },
    saveDescriptionRequest(index) {
      const item = this.table.items[index]
      api.cwsBack.post('/yandex_blocker/description/save', {
        object_id: item.object_id,
        description: item.description,
      }, {
        headers: {
          Authorization: sessionStorage.getItem('yb_token'),
        },
      }).catch(({ response }) => {
        if (response.status === 401) {
          sessionStorage.removeItem('yb_token')
          this.authForm.authorized = false
        }
      })
    },
    load() {
      api.cwsBack.post('/yandex_blocker/list', {
        filter: this.params,
      }, {
        headers: {
          Authorization: sessionStorage.getItem('yb_token'),
        },
      }).then(({ data }) => {
        this.table.items = data
      }).catch(({ response }) => {
        if (response.status === 401) {
          sessionStorage.removeItem('yb_token')
          this.authForm.authorized = false
        }
      })
    },
    loadChart() {
      api.cwsBack.post('/yandex_blocker/chart', {
        filter: this.params,
      }, {
        headers: {
          Authorization: sessionStorage.getItem('yb_token'),
        },
      }).then(({ data }) => {
        this.chartData = data
      }).catch(({ response }) => {
        if (response.status === 401) {
          sessionStorage.removeItem('yb_token')
          this.authForm.authorized = false
        }
      })
    },
    authorize(event) {
      this.prevent(event)
      api.cwsBack.post('/yandex_blocker/authorize', {
        login: this.authForm.login,
        password: this.authForm.password,
      }).then(({ data }) => {
        if (data.status) {
          sessionStorage.setItem('yb_token', data.token)
          this.authForm.authorized = true
          this.load()
          this.loadChart()
        } else {
          this.authForm.authError = true
        }
      }).catch(() => {
        this.authForm.authError = true
      })
    },
  },
}
</script>
